import { render, staticRenderFns } from "./ChatNavbarButton.vue?vue&type=template&id=c3a6901c"
import script from "./ChatNavbarButton.vue?vue&type=script&lang=js"
export * from "./ChatNavbarButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports